/**
 * Site Identity
 *
 * Single source of truth for the product name and tagline.
 *
 * NOTE: `SITE_NAME` is a working title, not a brand decision. Branding is
 * parked. Change it here and it propagates through the header, footer, page
 * titles, and logo aria-label — no other file hardcodes the name.
 */

export const SITE_NAME = 'Arena';

export const SITE_TAGLINE = 'A real-time multiplayer browser game.';

export const SITE_DESCRIPTION = 'Jump into a live arena and play against other people in your browser. No download, no install.';

export default SITE_NAME;
